import { ChevronRightIcon } from '@heroicons/react/solid';
import Link from 'next/link';
import { useRouter } from 'next/router';

const Breadcrumbs = () => {
  const router = useRouter();
  const pathWithoutQueryOrHash = (router.asPath || '').split(/[?#]/)[0] || '';
  const pathSegments = pathWithoutQueryOrHash
    .split('/')
    .filter((segment) => segment.length > 0);

  return (
    <nav className='py-2  rounded-lg'>
      <div className='flex items-center capitalize text-sm text-[#FFFFFF99]'>
        <Link
          href='/'
          className='text-[#FFFFFF99] text-xs md:text-sm xl:text-base hover:underline'
        >
          Home
        </Link>
        {pathSegments.length > 0 && (
          <span className='mx-1 md:mx-2 text-[#FFFFFF99]'>
            {' '}
            <ChevronRightIcon className='md:w-5 md:h-5 w-3.5 h-3.5' />
          </span>
        )}

        {/* Dynamic Breadcrumb Links */}
        {pathSegments.map((segment, index) => {
          const href = '/' + pathSegments.slice(0, index + 1).join('/');
          const isLast = index === pathSegments.length - 1;

          return (
            <span key={href} className='flex items-center'>
              <Link
                href={href}
                className={`truncate text-xs md:text-sm xl:text-base ${
                  isLast
                    ? 'text-white font-semibold  cursor-default pointer-events-none'
                    : 'text-[#FFFFFF99] hover:underline hover:text-gray-100'
                }`}
              >
                {decodeURIComponent(segment.replace(/-/g, ' '))}
              </Link>
              {!isLast && (
                <span className='mx-1 md:mx-2 text-[#FFFFFF99]'>
                  <ChevronRightIcon className='md:w-5 md:h-5 w-3.5 h-3.5' />
                </span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
